"use strict";

const client = document.querySelector("html").dataset.client;
const alertbar = document.querySelector(".alert-bar");
const closeAlertbart = document.querySelector(".alert-bar__close");
const isAlertbarClosed = window.sessionStorage.getItem(
  `${client}-alert-bar-hidden`
);

if (!isAlertbarClosed) alertbar.classList.remove("alert-bar--hidden");

if (alertbar && closeAlertbart) {
  closeAlertbart.addEventListener("click", () => {
    window.sessionStorage.setItem(`${client}-alert-bar-hidden`, true);
    alertbar.classList.add("alert-bar--hidden");
  });
}
